/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { request } from "../../../utils/request";
import Form from "./components/Form";
import { NotaDebitoContext } from "./Context";

const Edit = () => {
    const { id } = useParams();

    const [notaDebito, setNotaDebito] = useState({
		productos: [],
	});

    const getNotaDebito = () => {
		request("notas-debito/" + id).then((res) => {
			setNotaDebito(res.data);
		});
	};


    useEffect(() => {
        getNotaDebito();
    }, []);

    return (
        <NotaDebitoContext.Provider value={notaDebito}>
            <Form isEdit={true} />
        </NotaDebitoContext.Provider>
    );
};

export default Edit;